import { render, staticRenderFns } from "./TemplateRecords.vue?vue&type=template&id=b4ba950c&"
import script from "./TemplateRecords.vue?vue&type=script&lang=js&"
export * from "./TemplateRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports